export default __webpack_public_path__ + "static/media/token.7561c5a5.png";